import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { GenericModalService } from '../../../services/generic-modal.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {NodeConfigurationService} from '../../../services/configuration/node-configuration.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidator} from '../../../services/custom-validator';

@Component({
  selector: 'app-service-configuration-api',
  templateUrl: './service-configuration-inMemory.component.html',
  styleUrls: ['./service-configuration-inMemory.component.css']
})
export class ServiceConfigurationInMemoryComponent implements OnInit {

  @Input() modalTitle: string;
  componentForm: FormGroup;
  objInitialState;
  config;
  error;
  submitted;

  pleaseWait = false;
  get formData() { return this.componentForm.controls; }

  constructor(
    private nodeConfigService: NodeConfigurationService,
    private modalService: GenericModalService,
    private formBuilder: FormBuilder, public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.submitted= false;

    if (this.objInitialState){
      this.config = this.objInitialState;
    }
    this.createForm();
    this.loadConfigs();

  }

  createForm() {
    this.componentForm = this.formBuilder.group({
      periodRecalculateUserMetadataValues:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      dataCommunicationIp:[null,[ CustomValidator.trimRequired, Validators.maxLength(100) ]],
      dataCommunicationPort:[0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
    });
  }

  loadConfigs() {
    this.error = '';
    this.nodeConfigService.getByNode(this.config.machineId, this.config.hostName, 9)
      .subscribe(result => {
        if (result) {
          this.componentForm.patchValue({
            periodRecalculateUserMetadataValues:  result.periodRecalculateUserMetadataValues,
            dataCommunicationIp:  result.dataCommunicationIp,
            dataCommunicationPort:  result.dataCommunicationPort,
          });
          this.pleaseWait = false;

        }
      }, error1 => {
        this.error = error1;
        this.pleaseWait = false;
      });
  }

  onClose() {
    this.bsModalRef.hide();
  }

  onSave() {
    this.error = '';
    this.pleaseWait = true;
    const obj = this.componentForm.getRawValue();
    obj.machineId = this.config.machineId;
    obj.hostName = this.config.hostName;
    this.nodeConfigService.updateInMemory(obj).subscribe(
      () => {
        this.pleaseWait = false;
        this.submitted = true;
        setTimeout(() => {  this.submitted = false; }, 1700);
      }, error1 => {
        this.pleaseWait = false;
        this.error = error1;
      }
    );
  }

}
